const useQueryInitInfo = ({ isMobile }: { isMobile: boolean }) => {
  const { fetchInitInfo } = useFetchInitInfo()
  const { fetch: fetchQueryEventLabel } = useFetchQueryEventLabel()

  const fetch = async () => {
    try {
      const res = await fetchInitInfo()
      await fetchQueryEventLabel({ isMobile })

      return Promise.resolve(res)
    } catch (e) {
      return Promise.reject(e.data)
    }
  }

  return {
    fetch
  }
}

export default useQueryInitInfo
